import $ from 'jquery';

class Search{

    constructor(){
        //order ASCENDING or DESCENDING btns
        this.asc = $('#consultant-order-asc');
        this.desc = $('#consultant-order-desc');
        this.asc.addClass('active');
        this.desc.removeClass('active');
        this.order='asc';
        
        this.resultsDiv = $('#search_results');
        this.spinnerDiv = $('#loader');
        this.searchField = $('#search-term');

        this.typingTimer;
        this.emptyTimer;
        this.isSpinnerVisible = false;
        
        this.paginationContainer = $('#pagination-container');
        this.currentPage = 1;
        this.count = 0;
        this.posts_per_page = 24;
        this.previusValue;
        if(!this.isSpinnerVisible){
            this.resultsDiv.html('');
            this.spinnerDiv.html('<div class="spinner-loader "></div>');
            this.isSpinnerVisible = true;
       }
        this.events();
    }



    events(){
        this.searchField.on("keyup", this.typingLogic.bind(this));
       
        this.desc.on("click",this.orderDesc.bind(this));
        this.asc.on("click",this.orderAsc.bind(this));
    }

    typingLogic(){
        
        
        this.paginationContainer.html('');
        this.paginationContainer.empty();
        
        if(this.searchField.val() != this.previusValue){
            clearTimeout(this.typingTimer);
            
            // clearTimeout(this.emptyTimer);

            if(this.searchField.val()){
                if(!this.isSpinnerVisible){
                    this.resultsDiv.html('');
                    this.spinnerDiv.html('<div class="spinner-loader "></div>');
                    this.isSpinnerVisible = true;
               }
               this.currentPage = 1;
               this.typingTimer =setTimeout(this.getResults.bind(this), 2000);
               
            }else if(this.searchField.val() == ''){
                if(!this.isSpinnerVisible){
                    this.resultsDiv.html('');
                    this.spinnerDiv.html('<div class="spinner-loader "></div>');
                    this.isSpinnerVisible = true;
               }
               
               this.currentPage = 1;
               this.typingTimer =setTimeout(this.getAllResults.bind(this), 2000);
                
            }
           
        }
        this.previusValue = this.searchField.val();
    }

    orderDesc(){
        if(!this.isSpinnerVisible){
            this.resultsDiv.html('');
            this.spinnerDiv.html('<div class="spinner-loader "></div>');
            this.isSpinnerVisible = true;
       }
        this.asc.removeClass('active');
        this.desc.addClass('active');
        this.order='desc';
        this.getAllResults();
    }

    orderAsc(){
        if(!this.isSpinnerVisible){
            this.resultsDiv.html('');
            this.spinnerDiv.html('<div class="spinner-loader "></div>');
            this.isSpinnerVisible = true;
       }
        this.asc.addClass('active');
        this.desc.removeClass('active');
        this.order='asc';
        this.getAllResults();
    }

    pagination(event){
        if(!this.isSpinnerVisible){
            this.resultsDiv.html('');
            this.spinnerDiv.html('<div class="spinner-loader "></div>');
            this.isSpinnerVisible = true;
       }
        this.currentPage = event.data.page;
        this.getAllResults();
    }
    renderPagination(i){
        if(i  >= this.currentPage){
        this.count++;
        if(this.count == 1 && this.currentPage != this.count){
            this.pageLink = $('<button>');
        this.pageLink.attr('class','pagination_btn page-numbers  ');
        this.pageLink.html('<i class="fa-solid fa-chevron-left"></i>');
        this.pageLink.on('click',this.prevLink.bind(this));
        this.paginationContainer.append(this.pageLink);
        }
        if(this.count == 3 || (i == this.totalPages && this.count == 1) ){
        this.pageLink = $('<button>');
        this.pageLink.attr('class','pagination_btn page-numbers  ');
        this.pageLink.html('<i class="fa-solid fa-ellipsis"></i>');
        this.paginationContainer.append(this.pageLink);
        }
        if(this.count > 0 & this.count<3 || i == this.totalPages){
            
        this.pageLink = $('<button>');
        this.pageLink.attr('data-page', i);
        this.pageLink.attr('class','pagination_btn page-numbers  ');
        if(i == this.currentPage){
            this.pageLink.addClass('active');
        }
        this.pageLink.text(i);
        this.pageLink.on('click',{page:i},this.pagination.bind(this));
        this.paginationContainer.append(this.pageLink);
        }
        if(i == this.totalPages && this.currentPage != this.totalPages){
            this.pageLink = $('<button>');
            this.pageLink.attr('class','pagination_btn page-numbers  ');
            this.pageLink.html('<i class="fa-solid fa-chevron-right"></i>');
            this.pageLink.on('click',this.nextLink.bind(this));
            this.paginationContainer.append(this.pageLink);
            }
}
 

    }
    getAllResults(){
        console.log(this.posts_per_page)
            const url=`${siteURL.root_url}/wp-json/wp/v2/consultant?orderby=last_name&order=${this.order}&acf_format=standard&page=${this.currentPage}&posts_per_page=${this.posts_per_page}`;
   
            $.getJSON(url, (post,textStatus, jqXHR) =>{
                this.spinnerDiv.html('');
                this.resultsDiv.html(`
                ${post.map(item=>`<a href="${item.link}" class="consultant-item text-center " id="item-${item.id}">
                <div class="consultant-img-cont text-center m-auto">
                    <img  src="${item.acf.image.url}" alt="consultant" >
                </div>
                <p class="consultant-name text-capitalize">${item.title.rendered}</p>
                <p class="consultant-address text-capitalize">${item.acf.location}</p>
            </a>
                `).join('')}
                `);
            // Render pagination links
                this.totalPages = parseInt(jqXHR.getResponseHeader('X-WP-TotalPages'));
                this.paginationContainer.empty();
            if(this.totalPages <= 4){
            for (let i = 1; i <= this.totalPages; i++) {
                        this.pageLink = $('<button>');
                        this.pageLink.attr('data-page', i);
                        this.pageLink.attr('class','pagination_btn page-numbers  ');
                        this.pageLink.text(i);
                        if(i == this.currentPage){
                            this.pageLink.addClass('active');
                        }
                        this.pageLink.on('click',{page:i},this.pagination.bind(this));
                        this.paginationContainer.append(this.pageLink);
                    }
           }else{
                for (let i = 1; i <= this.totalPages; i++) {
                   
                    this.renderPagination(i);
                }
           }    
           
          
           this.totalPages=0;
                this.count = 0;
                this.isSpinnerVisible=false;
        });
        
        
    }
    nextLink(){
        this.currentPage++;
        this.getAllResults();
    }
    prevLink(){
        this.currentPage--;
        this.getAllResults();

    }
    // search pagination
    paginationSearch(event){
        console.log('pagination search')
        this.currentPage = event.data.page;
        this.getResults();
    }
    renderSearchPagination(i){
        if(i  >= this.currentPage){
        this.count++;
        if(this.count == 1 && this.currentPage != this.count){
            this.pageLink = $('<button>');
        this.pageLink.attr('class','pagination_btn page-numbers  ');
        this.pageLink.html('<i class="fa-solid fa-chevron-left"></i>');
        this.pageLink.on('click',this.prevSearchLink.bind(this));
        this.paginationContainer.append(this.pageLink);
        }
        if(this.count == 3 || (i == this.totalPages && this.count == 1) ){
        this.pageLink = $('<button>');
        this.pageLink.attr('class','pagination_btn page-numbers  ');
        this.pageLink.html('<i class="fa-solid fa-ellipsis"></i>');
        this.paginationContainer.append(this.pageLink);
        }
        if(this.count > 0 & this.count<3 || i == this.totalPages){
            
        this.pageLink = $('<button>');
        this.pageLink.attr('data-page', i);
        this.pageLink.attr('class','pagination_btn page-numbers  ');
        if(i == this.currentPage){
            this.pageLink.addClass('active');
        }
        this.pageLink.text(i);
        this.pageLink.on('click',{page:i},this.paginationSearch.bind(this));
        this.paginationContainer.append(this.pageLink);
        }
        if(i == this.totalPages && this.currentPage != this.totalPages){
            this.pageLink = $('<button>');
            this.pageLink.attr('class','pagination_btn page-numbers  ');
            this.pageLink.html('<i class="fa-solid fa-chevron-right"></i>');
            this.pageLink.on('click',this.nextSearchLink.bind(this));
            this.paginationContainer.append(this.pageLink);
            }
}
 

    }
    nextSearchLink(){
        console.log('pagination next search')
            this.currentPage++;
            this.getResults();
    }
    prevSearchLink(){
        console.log('pagination next search')
        this.currentPage--;
        this.getResults();

    }
    /**
     * Gets results form the search field
     */
    getResults(){
        const url=`${siteURL.root_url}/wp-json/wp/v2/consultant?search=${this.searchField.val()}&orderby=last_name&order=asc&acf_format=standard&page=${this.currentPage}`;
       
        $.getJSON(url, (post,textStatus, jqXHR) =>{
                this.spinnerDiv.html('');
                this.resultsDiv.html(`
                ${post.length ? '': 'Theres no match for the consultant'}
                ${post.map(item=>`<a href="${item.link}" class="consultant-item text-center" id="item-${item.id}">
                <div class="consultant-img-cont text-center m-auto">
                    <img  src="${item.acf.image.url}" alt="consultant" >
                </div>
                <p class="consultant-name text-capitalize">${item.title.rendered}</p>
                <p class="consultant-address text-capitalize">${item.acf.location}</p>
            </a>
                `).join('')}
                `);
            
            // Render pagination links
            this.totalPages = parseInt(jqXHR.getResponseHeader('X-WP-TotalPages'));
            this.paginationContainer.empty();
            if(this.totalPages > 1 ){
                if(this.totalPages <= 4){
                    for (let i = 1; i <= this.totalPages; i++) {
                                this.pageLink = $('<button>');
                                this.pageLink.attr('data-page', i);
                                this.pageLink.attr('class','pagination_btn page-numbers  ');
                                this.pageLink.text(i);
                                this.pageLink.on('click',{page:i},this.paginationSearch.bind(this));
                                this.paginationContainer.append(this.pageLink);
                            }
                   }else{
                        for (let i = 1; i <= this.totalPages; i++) {
                            
                            this.renderSearchPagination(i);
                        }
                   }
           }
           
           this.totalPages=0;
           this.count = 0;
            this.isSpinnerVisible=false;
        });
    }
}



export default Search